import { useEffect, useRef } from 'react'

export const useClickOutside = <T extends HTMLElement>(cb: () => void) => {
  const ref = useRef<T>(null)
  useEffect(() => {
    const clickOutsideListener = (event: MouseEvent | TouchEvent) => {
      if (!ref.current || ref.current.contains(event.target as Node)) {
        return
      }
      cb()
    }
    document.addEventListener('mousedown', clickOutsideListener)
    document.addEventListener('touchstart', clickOutsideListener)

    return () => {
      document.removeEventListener('mousedown', clickOutsideListener)
      document.removeEventListener('touchstart', clickOutsideListener)
    }
  }, [cb])

  return ref
}
